import { Automation } from './Automation'
import { WhoWeAre } from './WhoWeAre'
import DemoOne from './ui/demo'

export const Automationmain = () => {
  return (
    <>
      <Automation />
      <WhoWeAre />
      <DemoOne />
    </>
  )
}
